(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('before-after-slider')) {
    class BeforeAfterSlider extends HTMLElement {
      connectedCallback() {
        this.afterPanel = this.querySelector('[ref="afterPanel"]');
        this.handle = this.querySelector('[ref="handle"]');
        this.dragging = false;

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);

        this.addEventListener('pointerdown', this.onPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
      }

      disconnectedCallback() {
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
      }

      onPointerDown(event) {
        this.dragging = true;
        this.updatePosition(event.clientX);
      }

      onPointerMove(event) {
        if (!this.dragging) return;
        this.updatePosition(event.clientX);
      }

      onPointerUp() {
        this.dragging = false;
      }

      updatePosition(clientX) {
        const rect = this.getBoundingClientRect();
        let percent = ((clientX - rect.left) / rect.width) * 100;
        percent = Math.max(0, Math.min(100, percent));
        this.style.setProperty('--ba-position', percent + '%');
      }
    }
    customElements.define('before-after-slider', BeforeAfterSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-clientes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carrusel-clientes')) {
    customElements.define(
      'carrusel-clientes',
      class CarruselClientes extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('.ccf__slide'));
          this.count = this.slides.length;
          if (!this.count) return;
          this.active = 0;
          this.interval = Number(this.dataset.interval) || 3500;
          this.step = this.dataset.direction === 'right' ? -1 : 1;
          this.visible = false;
          this.paused = false;
          this.render();

          this.observer = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting;
            this.visible ? this.start() : this.stop();
          });
          this.observer.observe(this);

          this.addEventListener('mouseenter', () => { this.paused = true; });
          this.addEventListener('mouseleave', () => { this.paused = false; });
          this.addEventListener('click', (e) => {
            const slide = e.target.closest('.ccf__slide');
            if (slide) this.goTo(Number(slide.dataset.index));
          });

          let startX = null;
          this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; this.paused = true; }, { passive: true });
          this.addEventListener('touchend', (e) => {
            if (startX === null) return;
            const dx = e.changedTouches[0].clientX - startX;
            if (Math.abs(dx) > 40) this.goTo(this.active + (dx > 0 ? -1 : 1));
            startX = null;
            this.paused = false;
          });
        }

        disconnectedCallback() {
          this.stop();
          if (this.observer) this.observer.disconnect();
        }

        start() {
          if (this.timer || this.count < 2) return;
          // step -1: gira hacia la derecha; step 1: hacia la izquierda
          this.timer = setInterval(() => {
            if (!this.paused) this.goTo(this.active + this.step);
          }, this.interval);
        }

        stop() {
          clearInterval(this.timer);
          this.timer = null;
        }

        goTo(index) {
          this.active = ((index % this.count) + this.count) % this.count;
          this.render();
        }

        render() {
          const half = Math.floor(this.count / 2);
          this.slides.forEach((slide, i) => {
            let pos = i - this.active;
            if (pos > half) pos -= this.count;
            if (pos < -half) pos += this.count;
            if (pos > 3) pos = 3;
            if (pos < -3) pos = -3;
            slide.dataset.pos = pos;
            slide.setAttribute('aria-hidden', pos === 0 ? 'false' : 'true');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-gafas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carrusel-gafas')) {
    customElements.define(
      'carrusel-gafas',
      class CarruselGafas extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('.cg__slide'));
          this.count = this.slides.length;
          if (!this.count) return;
          this.active = 0;
          this.interval = Number(this.dataset.interval) || 0;
          this.paused = false;
          this.info = {
            name: this.querySelector('.cg__name'),
            sub: this.querySelector('.cg__sub'),
            amount: this.querySelector('.cg__amount'),
            compare: this.querySelector('.cg__compare'),
            buy: this.querySelector('.cg__buy'),
          };
          this.render();

          this.querySelectorAll('.cg__arrow').forEach((b) =>
            b.addEventListener('click', () => this.goTo(this.active + Number(b.dataset.dir)))
          );
          this.addEventListener('click', (e) => {
            const slide = e.target.closest('.cg__slide');
            if (!slide) return;
            const i = Number(slide.dataset.index);
            if (i === this.active) {
              if (slide.dataset.url) window.location.href = slide.dataset.url;
            } else this.goTo(i);
          });
          this.addEventListener('mouseenter', () => { this.paused = true; });
          this.addEventListener('mouseleave', () => { this.paused = false; });

          let startX = null;
          this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; this.paused = true; }, { passive: true });
          this.addEventListener('touchend', (e) => {
            if (startX === null) return;
            const dx = e.changedTouches[0].clientX - startX;
            if (Math.abs(dx) > 40) this.goTo(this.active + (dx > 0 ? -1 : 1));
            startX = null;
            this.paused = false;
          });

          if (this.interval > 0) {
            this.observer = new IntersectionObserver((entries) => {
              entries[0].isIntersecting ? this.start() : this.stop();
            });
            this.observer.observe(this);
          }
        }

        disconnectedCallback() {
          this.stop();
          if (this.observer) this.observer.disconnect();
        }

        start() {
          if (this.timer || this.count < 2) return;
          this.timer = setInterval(() => {
            if (!this.paused) this.goTo(this.active + 1);
          }, this.interval);
        }

        stop() {
          clearInterval(this.timer);
          this.timer = null;
        }

        goTo(index) {
          this.active = ((index % this.count) + this.count) % this.count;
          this.render();
        }

        render() {
          const half = Math.floor(this.count / 2);
          this.slides.forEach((slide, i) => {
            let pos = i - this.active;
            if (pos > half) pos -= this.count;
            if (pos < -half) pos += this.count;
            if (pos > 3) pos = 3;
            if (pos < -3) pos = -3;
            slide.dataset.pos = pos;
            slide.setAttribute('aria-hidden', pos === 0 ? 'false' : 'true');
          });
          const s = this.slides[this.active].dataset;
          this.info.name.textContent = s.label || '';
          this.info.sub.textContent = s.sub || '';
          this.info.sub.hidden = !s.sub;
          this.info.amount.textContent = s.price || '';
          this.info.compare.textContent = s.compare || '';
          this.info.compare.hidden = !s.compare;
          this.info.buy.href = s.url || '#';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
